import { i18n } from "@/plugins/i18n";

export class User {
  columns = [];
  id = "id";

  fillAbles = [
    ["firstName", i18n.t("firstName"), true],
    ["middleName", i18n.t("middleName"), true],
    ["lastName", i18n.t("lastName"), true],
    ["phoneNumber", i18n.t("phoneNumber"), true],
    ["controls", i18n.t("controls"), false],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility:
          process.env.VUE_APP_PROJECT_NAME === "MassHills" ? false : true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
